import React, { useMemo } from 'react'

import { useFilters } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

const List = () => {
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent pageFilters={pageFilters} />
    </PageContext.Provider>
  )
}

export default List
